export const LOGISTICS_ORDERS_RESET_STATE = 'LOGISTICS_ORDERS_RESET_STATE';
export const LOGISTICS_ORDERS_CURRENT_ITEM = 'LOGISTICS_ORDERS_CURRENT_ITEM';

export const LOGISTICS_ORDERS_REQUEST_LOADING = 'LOGISTICS_ORDERS_REQUEST_LOADING';
export const LOGISTICS_ORDERS_REQUEST_SUCCESS = 'LOGISTICS_ORDERS_REQUEST_SUCCESS';
export const LOGISTICS_ORDERS_REQUEST_FAILED = 'LOGISTICS_ORDERS_REQUEST_FAILED';

export const LOGISTICS_ORDERS_CURRENT_ACTION = 'LOGISTICS_ORDERS_CURRENT_ACTION';
export const LOGISTICS_ORDERS_RESET_ACTION = 'LOGISTICS_ORDERS_RESET_ACTION';